import { useEffect, useRef, useState } from 'react'
import path from 'path'
import _, { isNull } from 'lodash'
import moment from 'moment'

import {
    cerTopic,
    fileExt as fileExtConst,
    topicForLecturer,
    topicForStudent,
} from '../../../../../constants/constants'
import useLoading from '../../../../../control/loading/useLoading'
import useTranslate from '../../../../../i18n/useTranslate'
import { convertDateToDateString, dateForAPI } from '../../../../../utilities/date'
import checkPermission from '../../../../../utilities/checkPermission'
import * as REQServiceType from '../../../../../services/web/types/requestWebServiceTypes'

import useLookupService from '../../../../../services/lookup/useLookupService'
import useWebService from '../../../../../services/web/useWebService'

import useManageProjectStore from '../../../../../stores/manageProject/useManageProjectStore'

import useFolderAndTab from '../../useFolderAndTab'

import useAppAlertMessageAction from '../../../../../stores/appAlertMessage/appAlertMessageAction'
import useAppFolderAndTabAction from '../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import { DocumentInfo, GetCertificateByIDResultType } from '../../../../../services/web/types/responseWebServiceTypes'
import { UploadFileObjCerType } from './generateCertificateType'
import { ResultDocumentTopicLut } from '../../../../../services/lookup/types/responseLookupServiceTypes'
import { DialogType } from '../../../../../control/dialog/dialog'
import { GenerateCertificateREC1Type } from './generateCertificateREC1'
import constSubmittedStep from '../../../../../constants/submittedStep'
import constResearcherType from '../../../../../constants/researcherType'

import { TabSelectedType } from '../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import { FormRenderProps } from 'react-final-form'
import { useHistory } from 'react-router-dom'
import { RoutePath } from '../../../../../router/routesConfig'
import { validateModeAccordionError } from '../../../../../utilities/validate'
import { ResCoResearcher } from '../../flow/requestNewProject/researcher/researcherOtherType'
type CerDialogType = Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>
const useGenerateCertificate = (props: GenerateCertificateREC1Type) => {
    const { callbackSaveComplete } = props
    const translate = useTranslate()
    const manageProjectStore = useManageProjectStore()

    const { projectData } = manageProjectStore
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const appAlertMessageAction = useAppAlertMessageAction()

    const tabAndFolderHook = useFolderAndTab()

    const callWebService = useWebService()
    const callLookup = useLookupService()
    const loadingHook = useLoading()
    const checkPermissionHook = checkPermission()

    const [configDialog, setConfigDialog] = useState<CerDialogType>()
    const dialogRef = useRef<Record<string, Function>>()

    const [initialUploadCerDoc, setInitialUploadCerDoc] = useState<any>()
    const [initialUploadFileCer, setInitialUploadFileCer] = useState<any>()
    const [initialValues, setInitialValues] = useState<any>({})
    const [initialValuesOtherLanguage, setInitialValuesOtherLanguage] = useState<any>({})

    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const isShowUpdateDate = checkPermissionHook.chkShowUpdateDate(projectData)

    const [disabledFieldNames, setdisabledFieldNames] = useState<Array<string> | 'all'>('all')
    const [certificateData, setCertificateData] = useState<GetCertificateByIDResultType>()
    const [documentTopicData, setDocumentTopicData] = useState<ResultDocumentTopicLut[]>()
    const [isUpdateSuccess, setIsUpdateSuccess] = useState<boolean>(false)
    const [isAddOtherLanguage, setIsAddOtherLanguage] = useState<boolean>(false)
    const formRef = useRef<FormRenderProps>()
    const valueRef = useRef<{ [key: string]: any }>({})
    const history = useHistory()

    useEffect(() => {
        const initail = async () => {
            await createInitialData()
        }
        if (projectData) {
            if (projectData?.stepID === constSubmittedStep.certification) {
                //draft editmode
                setdisabledFieldNames(['coaNo', 'dateCertificateExpire'])
            } else {
                //view mode
                setdisabledFieldNames('all')
                appFolderAndTabAction.setTabDirty(false)
            }
            initail()
        }
    }, [])

    const getResearcherName = (data: ResCoResearcher, lang: 'th' | 'en') => {
        const isTh = lang === 'th'

        const titleValue = data.titleName?.value?.toString()
        const isOtherTitle = titleValue === '5'
        const isNoTitle = titleValue === '4'

        let titleName: string | undefined

        if (isNoTitle) {
            titleName = undefined
        } else if (isOtherTitle) {
            titleName = isTh ? data.otherTitleNameTh : data.otherTitleNameEn
        }

        const name = isTh ? data.nameTh : data.nameEn

        return [titleName, name].filter(Boolean).join(' ')
    }

    const createInitialData = async () => {
        if (projectData) {
            const submittedID = projectData.submittedID
            loadingHook.loadingOpen()
            const { result } = await callWebService.getCertificateByID(submittedID)
            const docTopicData = await getCarDoc()
            loadingHook.loadingClose()
            let initialData = {}
            let initialDataOtherLanguage = {}
            if (result) {
                const filterDocCertificate = result.documentInfo.filter((itm) => {
                    return itm.fileInfo.length > 0
                })
                let docCertificateTH = '-'
                let docCertificateEN = '-'
                filterDocCertificate.forEach((item, index) => {
                    let objDocCer = docTopicData?.find((e: { id: number }) => e.id === item.topicID)
                    docCertificateTH =
                        docCertificateTH === '-'
                            ? `${index + 1}. ${objDocCer?.name_th}`
                            : `${docCertificateTH}\n${index + 1}. ${objDocCer?.name_th.trim()}`
                    docCertificateEN =
                        docCertificateEN === '-'
                            ? `${index + 1}. ${objDocCer?.name_en}`
                            : `${docCertificateEN}\n${index + 1}. ${objDocCer?.name_en.trim()}`
                })
                // const isExempt = projectData?.considerInfo?.value === constConsiderType.exempt
                // let detailTH
                // let detailEN
                // let conditionTH
                // let conditionEN

                // if (projectData.irb === 1) {
                //     if (isExempt) {
                //         //รายละเอียด
                //         detailTH = configCertificate.descriptionIRB1Exempt.nameTH
                //         detailEN = configCertificate.descriptionIRB1Exempt.nameEN
                //         //เงื่อนไข
                //         conditionTH = configCertificate.conditionIRB1Exempt.nameTH
                //         conditionEN = configCertificate.conditionIRB1Exempt.nameEN
                //     } else {
                //         detailTH = configCertificate.descriptionIRB1.nameTH
                //         detailEN = configCertificate.descriptionIRB1.nameEN
                //         //เงื่อนไข
                //         conditionTH = configCertificate.conditionIRB1.nameTH
                //         conditionEN = configCertificate.conditionIRB1.nameEN
                //     }
                // } else {
                //     detailTH = configCertificate.descriptionIRB2.nameTH
                //     detailEN = configCertificate.descriptionIRB2.nameEN
                //     //เงื่อนไข
                //     conditionTH = configCertificate.conditionIRB2.nameTH
                //     conditionEN = configCertificate.conditionIRB2.nameEN
                // }

                initialData = {
                    dateReqCertificate: result.exportDate ? new Date(result.exportDate) : new Date(),
                    dateCertificateExpire: result.expireDate
                        ? new Date(result.expireDate)
                        : moment(new Date()).subtract(1, 'day').add(1, 'year').format('YYYY-MM-DD'),
                    coaNo: result.coaNo,
                    certificateId: result.certificateId,
                    coResearcher: result.coResearcher,
                }

                const coResearcher = result.coResearcher?.filter((e) => e.researcherRoleTypeId !== 1) ?? []
                const coResearchersTextDisplayTh = coResearcher.map((r) => getResearcherName(r, 'th')).join(', ')
                const coResearchersTextDisplayEn = coResearcher.map((r) => getResearcherName(r, 'en')).join(', ')

                if (projectData?.isLanguageEN) {
                    initialData = {
                        ...initialData,
                        projectNameEN: result.projectName_en ? result.projectName_en : projectData.projectName_en,
                        nameEN: result.researcherName_en ? result.researcherName_en : null,
                        docCertificateEN: result.docsCertified_en ? result.docsCertified_en : docCertificateEN,
                        conditionEN: result.condition_en ? result.condition_en.trim() : null,
                        detailEN: result.description_en ? result.description_en.trim() : null,
                        coResearcherEN: result.coResearcher_en ? result.coResearcher_en.trim() : null,
                        coResearcherNameEN: result.coResearcherNameEn ?? coResearchersTextDisplayEn ?? null,
                    }
                } else {
                    initialDataOtherLanguage = {
                        ...initialDataOtherLanguage,
                        projectNameEN: result.projectName_en ? result.projectName_en : projectData.projectName_en,
                        nameEN: result.researcherName_en ? result.researcherName_en : null,
                        docCertificateEN: result.docsCertified_en ? result.docsCertified_en : docCertificateEN,
                        conditionEN: result.condition_en ? result.condition_en.trim() : null,
                        detailEN: result.description_en ? result.description_en.trim() : null,
                        coResearcherEN: result.coResearcher_en ? result.coResearcher_en.trim() : null,
                        coResearcherNameEN: result.coResearcherNameEn ?? coResearchersTextDisplayEn ?? null,
                    }
                }
                if (projectData?.isLanguageTH) {
                    initialData = {
                        ...initialData,
                        projectNameTH: result.projectName_th ? result.projectName_th : projectData.projectName_th,
                        nameTH: result.researcherName_th ? result.researcherName_th : null,
                        docCertificateTH: result.docsCertified_th ? result.docsCertified_th : docCertificateTH,
                        conditionTH: result.condition_th ? result.condition_th.trim() : null,
                        detailTH: result.description_th ? result.description_th.trim() : null,
                        coResearcherTH: result.coResearcher_th ? result.coResearcher_th.trim() : null,
                        coResearcherNameTH: result.coResearcherNameTh ?? coResearchersTextDisplayTh ?? null,
                    }
                } else {
                    initialDataOtherLanguage = {
                        ...initialDataOtherLanguage,
                        projectNameTH: result.projectName_th ? result.projectName_th : projectData.projectName_th,
                        nameTH: result.researcherName_th ? result.researcherName_th : null,
                        docCertificateTH: result.docsCertified_th ? result.docsCertified_th : docCertificateTH,
                        conditionTH: result.condition_th ? result.condition_th.trim() : null,
                        detailTH: result.description_th ? result.description_th.trim() : null,
                        coResearcherTH: result.coResearcher_th ? result.coResearcher_th.trim() : null,
                        coResearcherNameTH: result.coResearcherNameTh ?? coResearchersTextDisplayTh ?? null,
                    }
                }
            }

            setInitialValues(initialData)
            setInitialValuesOtherLanguage(initialDataOtherLanguage)
            setCertificateData(result)
            createInitialUploadFileCer(result?.certificateInfo)
            createInitialUploadFileCerDoc(result?.documentInfo)
        }
    }

    const reloadCertificate = async () => {
        if (projectData?.submittedID) {
            const { result } = await callWebService.getCertificateByID(projectData.submittedID)
            if (result) {
                setCertificateData(result)
                createInitialUploadFileCer(result?.certificateInfo)
                createInitialUploadFileCerDoc(result?.documentInfo)
            }
        }
    }

    const getCarDoc = async () => {
        if (projectData) {
            const lutTop = await callLookup.callDocumentTopicLut(projectData.irb, projectData?.submitTypeInfo.value)
            const docTopic = filterDocTopic(lutTop.result, projectData?.researcherTypeInfo.value)

            setDocumentTopicData(docTopic)

            return docTopic
        }
    }

    const filterDocTopic = (documentInfo: ResultDocumentTopicLut[], researcherTypeID: number) => {
        let docTopic: ResultDocumentTopicLut[] = []
        if (documentInfo) {
            let isDocTopic = documentInfo
            if (researcherTypeID === constResearcherType.student) {
                topicForLecturer.forEach((element) => {
                    docTopic = documentInfo?.filter((item: any) => {
                        return item.id !== element.id
                    })
                })
            } else {
                topicForStudent.forEach((element) => {
                    docTopic = isDocTopic?.filter((item: any) => {
                        return item.id !== element.id
                    })
                    isDocTopic = docTopic
                })
            }

            if (docTopic.length > 1) {
                docTopic = docTopic?.map((itm, index: number) => {
                    return { ...itm, no: index + 1 }
                })
            }
        }
        return docTopic
    }

    const createInitialUploadFileCerDoc = async (documentInfo: any) => {
        let docTopic: DocumentInfo[] = []
        const researcherTypeID = projectData?.researcherTypeInfo.value

        if (documentInfo) {
            let isDocTopic = documentInfo
            if (researcherTypeID === constResearcherType.student) {
                topicForLecturer.forEach((element) => {
                    docTopic = documentInfo?.filter((item: any) => {
                        return item.topicID !== element.id
                    })
                })
            } else {
                topicForStudent.forEach((element) => {
                    docTopic = isDocTopic?.filter((item: any) => {
                        return item.topicID !== element.id
                    })
                    isDocTopic = docTopic
                })
            }
            let uploadFileinitCerDoc = await docTopic?.map((itm: any, idx: number) => {
                return {
                    uploadFileObj: {
                        fileList: itm.fileInfo,
                        subTopicPageList: itm.subtopic,
                        documentTopicID: itm.topicID,
                        isDisplay: itm.isDisplay,
                        isRequired: itm.isRequired,
                    },
                }
            })
            //Filter การซ่อนแสดงหัวข้อเอกสาร ถ้าฝั่งสำนักงานให้ซ่อนหัวข้อเอกสาร แต่ว่าหัวข้อนั้นมีไฟล์อยู่ให้ทำการแสดงหัวข้อนั้นออกมา
            if (uploadFileinitCerDoc?.length > 0) {
                uploadFileinitCerDoc = uploadFileinitCerDoc.filter((itm: any) => {
                    return itm.uploadFileObj.isDisplay || itm.uploadFileObj.fileList.length !== 0
                })
            }
            setInitialUploadCerDoc(uploadFileinitCerDoc)
        }
        // //เอกสารที่ประทับตรารับรองแล้ว
    }

    const createInitialUploadFileCer = (cerInfo: any) => {
        const uploadFileCerinit: Array<UploadFileObjCerType> = cerTopic?.map((itm: any, idx: number) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    subTopicPageList: [],
                    documentTopicID: itm.id,
                },
            }
        })
        uploadFileCerinit.forEach((itm: UploadFileObjCerType) => {
            if (itm.uploadFileObj.documentTopicID === 0) {
                if (cerInfo?.cer_th) {
                    let fileListTH = {
                        documentTopicID: 0,
                        fileToken: cerInfo?.certificateFileName_th,
                        filename: cerInfo?.certificateFileName_th,
                        fileID: cerInfo?.certificateFileName_th,
                        path: cerInfo?.cer_th,
                    }
                    //@ts-ignore
                    itm.uploadFileObj.fileList.push(fileListTH)
                }
            } else if (itm.uploadFileObj.documentTopicID === 1) {
                if (cerInfo?.cer_en) {
                    let fileListEN = {
                        documentTopicID: 1,
                        fileToken: cerInfo?.certificateFileName_en,
                        filename: cerInfo?.certificateFileName_en,
                        fileID: cerInfo?.certificateFileName_en,
                        path: cerInfo?.cer_en,
                    }
                    //@ts-ignore
                    itm.uploadFileObj.fileList.push(fileListEN)
                }
            }

            itm.uploadFileObj.subTopicPageList = []
        })
        setInitialUploadFileCer(uploadFileCerinit)
    }

    const getCerTopic = () => {
        let myCerTopic = cerTopic
        if (!certificateData?.certificateInfo?.cerSign_en) {
            myCerTopic = cerTopic.filter((itm) => itm.id !== 1)
        }
        if (!certificateData?.certificateInfo?.cerSign_th) {
            myCerTopic = cerTopic.filter((itm) => itm.id !== 0)
        }
        return myCerTopic
    }

    const getTopicDoc = () => {
        return documentTopicData?.map((item: any) => {
            return { ...item, subtopic: [] }
        })
    }

    const handleDirtyChange = (props: { dirty: boolean; values: any }) => {
        let isDirty: boolean = false
        //** จัดformat initValue และ Form Value เพื่อเตรียมตัวนำไปใช้เปรียบเทียบค่า  **//
        let newFormValue = _.omit(
            {
                ...props.values,
                dateReqCertificate: props.values.dateReqCertificate
                    ? convertDateToDateString(props.values.dateReqCertificate)
                    : null,
            },
            ['uploadFile', 'uploadFileCerDoc', 'dateCertificateExpire'],
        )
        let initValue = _.omit(
            {
                ...initialValues,
                dateReqCertificate: initialValues.dateReqCertificate
                    ? convertDateToDateString(initialValues.dateReqCertificate)
                    : null,
            },
            ['uploadFile', 'uploadFileCerDoc', 'dateCertificateExpire'],
        )
        //**********************************************************//
        const initialKeys = Object.keys(initValue)
        const newValueKeys = Object.keys(newFormValue)
        const omitKeys = newValueKeys.filter((value) => !initialKeys.includes(value))
        const isEqual = _.isEqual(initValue, _.omit(newFormValue, omitKeys)) //ข้อมูลเท่ากัน

        if (!isViewMode) {
            if (isEqual) {
                isDirty = false
            } else {
                isDirty = true
            }
        }

        const paramsDirty = {
            tabDirty: isDirty,
            callbackDirty: isDirty ? callbackDirtyProcess : undefined,
        }

        appFolderAndTabAction.setDirty(paramsDirty)
    }

    const callbackDirtyProcess = (tabIndex: number, newTabSelected: any) => {
        const isDraft = true
        const param: REQServiceType.CertificateType = getSaveServiceParameter(isDraft)
        processSaveData(param, tabIndex, newTabSelected)
    }
    const processSaveData = async (
        param: REQServiceType.CertificateType,
        tabIndex: number | null = null,
        newTabSelected: TabSelectedType | null = null,
        isReloadCertificate = false,
    ) => {
        dialogRef.current?.closeDialog()
        loadingHook.loadingOpen()
        const response = await callWebService.certificate(param)

        //if นี้จะเช็คว่าเป็นการติด dirty จากการกดเปลี่ยน folder ใช่หรือไม่?
        if (tabIndex && newTabSelected) {
            //if นี้จะเช็คว่าเป็นการติด dirty จากการกดเปลี่ยน Tab ใช่หรือไม่?
            tabAndFolderHook.setTab(tabIndex, newTabSelected)
        } else {
            //หากเข้า else หมายความว่าเป็นการบันทึกจากกดปุ่มบันทึกไม่ใช่จากการติด dirty
            if (callbackSaveComplete) {
                if (response && response.status) {
                    callbackSaveComplete(response.status, param.isDraft as boolean)
                    isReloadCertificate && (await reloadCertificate())
                }
            }
        }
        loadingHook.loadingClose()
    }

    const handleDateReqCertificateChange = (date: string) => {
        if (date && typeof date === 'string' && date.trim() != '') {
            const certificateExpireDate = moment(date).add(1, 'year').subtract(1, 'days')
            if (formRef.current) {
                const form = formRef.current?.form
                form.change?.('dateCertificateExpire', certificateExpireDate)
            }
        }
    }
    const handleClickOpenFile = async (url: string) => {
        let xmlHttp = new XMLHttpRequest()
        xmlHttp.open('GET', url, true) // false for synchronous request
        xmlHttp.onreadystatechange = function () {
            // In local files, status is 0 upon success in Mozilla Firefox
            if (xmlHttp.readyState === XMLHttpRequest.DONE) {
                var status = xmlHttp.status
                if (status === 0 || (status >= 200 && status < 400)) {
                    // The request has been completed successfully
                    window.open(url)
                } else {
                    // Oh no! There has been an error with the request!
                    appAlertMessageAction.openAlertMessage({
                        title: translate.get('ALERT.TITLE.NOTIFICATION'),
                        message: translate.get('MESSAGE.M011'),
                    })
                }
            }
        }
        xmlHttp.send()
    }

    const handleClickFileStamp = (filePath: string, fileName: string) => {
        const fileExt = path.extname(`${fileName}`)
        if (fileExt !== fileExtConst.pdf) {
            appAlertMessageAction.openAlertMessage({
                title: translate.get('ALERT.TITLE.WARNING'),
                message: translate.get('ALERT.CONTENT.CAN_OPEN_ONLY_PDF'),
            })
        } else {
            handleClickOpenFile(filePath)
        }
    }
    const getSaveServiceParameter = (isDraft: boolean) => {
        const val = formRef.current?.values
        const submittedID = projectData ? (projectData.submittedID ?? isNull) : null

        const certificateServiceParam: REQServiceType.CertificateType = {
            certificateId: val && val.certificateId ? val.certificateId : null,
            submittedId: submittedID,
            coaNo: val && val.coaNo ? parseInt(val.coaNo) : null,
            projectName_th: val && val.projectNameTH ? val.projectNameTH : null,
            projectName_en: val && val.projectNameEN ? val.projectNameEN : null,
            researcherName_th: val && val.nameTH ? val.nameTH : null,
            researcherName_en: val && val.nameEN ? val.nameEN : null,
            description_th: val && val.detailTH ? val.detailTH : null,
            description_en: val && val.detailEN ? val.detailEN : null,
            docsCertified_th: val && val.docCertificateTH ? val.docCertificateTH : null,
            docsCertified_en: val && val.docCertificateEN ? val.docCertificateEN : null,
            condition_th: val && val.conditionTH ? val.conditionTH : null,
            condition_en: val && val.conditionEN ? val.conditionEN : null,
            exportDate: val?.dateReqCertificate ? (dateForAPI(val?.dateReqCertificate) ?? null) : null,
            expireDate: val?.dateCertificateExpire ? (dateForAPI(val?.dateCertificateExpire) ?? null) : null,
            isDraft: isDraft,
            coResearcherNameTh: val?.coResearcherNameTH ?? null,
            coResearcherNameEn: val?.coResearcherNameEN ?? null,
        }
        return certificateServiceParam
    }
    const handleSubmitForm = async (val: any) => {
        if (projectData?.projectID && projectData?.submittedID) {
            const isDraft: boolean = val?.saveType !== 'SAVE'
            const certificateServiceParam = getSaveServiceParameter(isDraft)

            if (val.saveType === 'SAVE') {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
                    type: 'alert-confirm',
                    onClickConfirm: () => {
                        processSaveData(certificateServiceParam)
                    },
                })
                dialogRef.current?.openDialog()
            } else {
                //ถ้า save draft ไม่ต้องมี alert confirm
                processSaveData(certificateServiceParam, null, null, true)
            }
            if (isAddOtherLanguage) {
                const projectID = projectData?.projectID
                const submittedID = projectData?.submittedID
                const isLanguageTh = true
                const isLanguageEn = true
                await callWebService.updateLanguage({
                    projectID,
                    submittedID,
                    isLanguageEn,
                    isLanguageTh,
                })
            }
        }
    }

    const onRefDialog = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogRef.current = func
    }

    const handleBackToSearch = () => {
        history.push(RoutePath.manageProject)
    }

    const updateCertificateData = async (params: REQServiceType.CertificateDataType) => {
        loadingHook.loadingOpen()
        dialogRef.current?.closeDialog()
        setIsAddOtherLanguage(false)
        const res = await callWebService.updateCertificataData(params)

        if (res.result.status === 200) {
            if (
                !(params.projectNameTH && projectData?.isLanguageTH) &&
                !(params.projectNameEN && projectData?.isLanguageEN)
            ) {
                const projectID = Number(projectData?.projectID)
                const submittedID = Number(projectData?.submittedID)
                const isLanguageTh = true
                const isLanguageEn = true
                const result = await callWebService.updateLanguage({
                    projectID,
                    submittedID,
                    isLanguageEn,
                    isLanguageTh,
                })
                reloadCertificate()
                tabAndFolderHook.reloadProjectData()
                setIsUpdateSuccess(result.status === 1)
            }
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
                type: 'alert-message',
                onAfterClose: () => {
                    setConfigDialog({})
                },
            })
            dialogRef.current?.openDialog()
        }
        loadingHook.loadingClose()
    }

    const handleSubmitUpdateData = async (
        val: any,
        formProps: FormRenderProps<any, any>,
        language: string,
        fieldNames: string[],
    ) => {
        const isError = validateModeAccordionError(fieldNames, formProps)
        return new Promise(async (resolve, reject) => {
            if (isError) {
                formProps.form.submit()
                reject('')
            } else {
                resolve('')
                dialogRef.current?.openDialog()
                if (projectData?.projectID && projectData?.submittedID) {
                    const certificateDataServiceTH: REQServiceType.CertificateDataType | any = {
                        submittedID: projectData?.submittedID,
                        projectNameTH: val && val.projectNameTH ? val.projectNameTH : null,
                        researcherNameTH: val && val.nameTH ? val.nameTH : null,
                        descriptionTH: val && val.detailTH ? val.detailTH : null,
                        docCertificateTH: val && val.docCertificateTH ? val.docCertificateTH : null,
                        conditionTH: val && val.conditionTH ? val.conditionTH : null,
                        coResearcherNameTh: val?.coResearcherNameTH ?? null,
                    }

                    const certificateDataServiceEN: REQServiceType.CertificateDataType | any = {
                        submittedID: projectData?.submittedID,
                        projectNameEN: val && val.projectNameEN ? val.projectNameEN : null,
                        researcherNameEN: val && val.nameEN ? val.nameEN : null,
                        descriptionEN: val && val.detailEN ? val.detailEN : null,
                        docCertificateEN: val && val.docCertificateEN ? val.docCertificateEN : null,
                        conditionEN: val && val.conditionEN ? val.conditionEN : null,
                        coResearcherNameEn: val?.coResearcherNameEN ?? null,
                    }
                    if (language === 'TH') {
                        updateCertificateData(certificateDataServiceTH)
                    } else {
                        updateCertificateData(certificateDataServiceEN)
                    }
                }
            }
        })
    }

    const handleClickOtherLangauge = () => {
        setIsAddOtherLanguage(true)
    }
    const handleCancelAddOtherLangauge = () => {
        setIsAddOtherLanguage(false)
    }
    return {
        formRef,
        valueRef,
        isViewMode,
        projectData,
        configDialog,
        initialValues,
        initialValuesOtherLanguage,
        isShowUpdateDate,
        disabledFieldNames,
        initialUploadCerDoc,
        initialUploadFileCer,
        certificateTopicList: getCerTopic(),
        formatDocumentTopic: getTopicDoc(),
        onRefDialog,
        handleDirtyChange,
        onSubmitForm: handleSubmitForm,
        onClickOpenFile: handleClickOpenFile,
        onClickFileStamp: handleClickFileStamp,
        onDateReqCertificateChange: handleDateReqCertificateChange,
        handleBackToSearch,
        handleSubmitUpdateData,
        isUpdateSuccess,
        certificateFieldNamesTH: ['projectNameTH', 'nameTH', 'detailTH', 'docCertificateTH', 'conditionTH'],
        certificateFieldNamesEN: ['projectNameEN', 'nameEN', 'detailEN', 'docCertificateEN', 'conditionEN'],
        isAddOtherLanguage,
        handleCancelAddOtherLangauge,
        handleClickOtherLangauge,
    }
}
export default useGenerateCertificate
